import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import classnames from 'classnames';
import { convertTimeValues } from './utils/convertTimeValues';
import styles from './DisplayValues.css';
export const DisplayValues = memo(function DisplayValues({ value, titleOfValue, timerValueClassName, timerTagClassName, }) {
    return (_jsxs("div", Object.assign({ className: styles.item }, { children: [_jsx("span", Object.assign({ className: classnames(styles.value, timerValueClassName) }, { children: convertTimeValues(value, titleOfValue) }), void 0), _jsx("span", Object.assign({ className: classnames(styles.tag, timerTagClassName) }, { children: titleOfValue }), void 0)] }), void 0));
});
